import script from "./CreateEmployee.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateEmployee.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__